export enum STATUS {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  LOADING = 'LOADING',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export const SESSION_ACTIONS = {
  SESSION_DATA: 'SESSION_DATA',
  DELETE_DATA: 'DELETE_DATA',
};

export const REQUEST_ACTIONS = {
  GET_USER: 'GET_USER',
  UPDATE_USER: 'UPDATE_USER',
  PASSWORD_RESET: 'PASSWORD_RESET',
  NEW_PASSWORD: 'NEW_PASSWORD',
  SIGNUP: 'SIGNUP',
  CREATE_ORGANISATION: 'CREATE_ORGANISATION',
  CUSTOMER_LIST: 'CUSTOMER_LIST',
  CUSTOMER_LIST_RAW: 'CUSTOMER_LIST_RAW',
  SINGLE_CUSTOMER: 'SINGLE_CUSTOMER',
  CREATE_CUSTOMER: 'CREATE_CUSTOMER',
  LOCATION_LIST: 'LOCATION_LIST',
  LOCATION_CHANNELS: 'LOCATION_CHANNELS',
  LOCATION_UPDATE: 'LOCATION_UPDATE',
  LOCATION_CREATE: 'LOCATION_CREATE',
  STAFF_LIST: 'STAFF_LIST',
  STAFF_UPDATE: 'STAFF_UPDATE',
  STAFF_CREATE: 'STAFF_CREATE',
  TRAINER_LIST: 'TRAINER_LIST',
  GET_AVAILABLE_PROVIDERS: 'GET_AVAILABLE_PROVIDERS',
  GET_PROVIDER: 'GET_PROVIDER',
  UPDATE_PROVIDER: 'UPDATE_PROVIDER',
  GET_EVENT_LIST: 'GET_EVENT_LIST',
  GET_CHECK_LIST: 'GET_CHECK_LIST',
  GET_EVENTGROUP: 'SINGLE_EVENTGROUP',
  GET_EVENTGROUP_LIST: 'GET_EVENTGROUP_LIST',
  GET_NEXT_EVENTS: 'GET_NEXT_EVENTS',
  GET_CLIENT_NAME: 'GET_CLIENT_NAME',
  GET_ACTIVE_LOCATIONS: 'GET_ACTIVE_LOCATIONS',
  GET_ACTIVE_INTEGRATIONS: 'GET_ACTIVE_INTEGRATIONS',
  GET_INTEGRATION_DATES: 'GET_INTEGRATION_DATES',
  GET_ALL_INTEGRATION_CHANNELS: 'GET_ALL_INTEGRATION_CHANNELS',
  GET_INTEGRATION_BY_ID: 'GET_INTEGRATION_BY_ID',
  GET_PROD_INTEGRATIONS: 'GET_PROD_INTEGRATIONS',
  DELETE_NEXT_EVENT_BY_GROUP_ID: 'DELETE_NEXT_EVENT_BY_GROUP_ID',
  GET_SYNCED_EVENT_GROUP_LIST: 'GET_SYNCED_EVENT_GROUP_LIST',
  PATCH_EVENTGROUP: 'EVENTGROUP_LIST_UPDATE',
  POST_EVENTGROUP: 'EVENTGROUP_CREATE',
  POST_CLIENT_ROLE: 'POST_CLIENT_ROLE',
  POST_MAGICLINE_CHANNEL: 'POST_MAGICLINE_CHANNEL',
  POST_VIRTUAGYM_CHANNEL: 'POST_VIRTUAGYM_CHANNEL',
  POST_VIRTUAGYMV1_CHANNEL: 'POST_VIRTUAGYMV1_CHANNEL',
  POST_MINDBODY_CHANNEL: 'POST_MINDBODY_CHANNEL',
  POST_RESAMANIA_CHANNEL: 'POST_RESAMANIA_CHANNEL',
  UPDATE_MAGICLINE_CHANNEL: 'UPDATE_MAGICLINE_CHANNEL',
  UPDATE_CHANNEL_CATEGORIES: 'UPDATE_CHANNEL_CATEGORIES',
  ACTIVATE_MAGICLINE_CHANNEL: 'ACTIVATE_MAGICLINE_CHANNEL',
  DEACTIVATE_MAGICLINE_CHANNEL: 'DEACTIVATE_MAGICLINE_CHANNEL',
  FETCH_CHANNEL_CATEGORIES: 'FETCH_CHANNEL_CATEGORIES',
  GET_CHANNEL_CATEGORIES: 'GET_CHANNEL_CATEGORIES',
  CLEANUP_CHANNEL: 'CLEANUP_CHANNEL',
  DELETE_EVENTGROUP: 'DELETE_EVENTGROUP',
  SINGLE_EVENT: 'SINGLE_EVENT',
  BOOKING_LIST: 'BOOKING_LIST',
  LIMITATION_LIST: 'LIMITATION_LIST',
  BOOKING_PRESENCE_UPDATE: 'BOOKING_PRESENCE_UPDATE',
  BOOKING_UPDATE: 'BOOKING_UPDATE',
  BOOKING_UPDATE_SINGLE: 'BOOKING_UPDATE_SINGLE',
  BOOKING_UPDATE_PRESENCE_MULTIPLE: 'BOOKING_PRESENCE_UPDATE_MULTIPLE',
  BOOKING_CREATE_SINGLE: 'BOOKING_CREATE_SINGLE',
  BOOKING_SUMMARY: 'BOOKING_SUMMARY',
  SEARCH: 'SEARCH',
  SEARCH_BOOKABLE_CUSTOMERS: 'SEARCH_BOOKABLE_CUSTOMERS',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  INVITE_CUSTOMER: 'INVITE_CUSTOMER',
  DISCONNECT_CUSTOMER: 'DISCONNECT_CUSTOMER',
  EVENT_PRODUCTS: 'EVENT_PRODUCTS',
  PRODUCT_CHECKOUT: 'PRODUCT_CHECKOUT',
  CUSTOMER_ACTIVE_ORDERLINES: 'CUSTOMER_ACTIVE_ORDERLINES',
  CUSTOMER_ARCHIVED_ORDERLINES: 'CUSTOMER_ARCHIVED_ORDERLINES',
  CUSTOMER_EVENT_ORDERLINES: 'CUSTOMER_EVENT_ORDERLINES',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  CREATE_PAYMENT_FOR_ORDERLINE: 'CREATE_PAYMENT_FOR_ORDERLINE',
  CREATE_ORDERLINE: 'CREATE_ORDERLINE',
  SEARCH_PROVIDERS: 'SEARCH_PROVIDERS',
  UPDATE_EVENT: 'UPDATE_EVENT',
  CREATE_EVENT: 'CREATE_EVENT',
  UPDATE_EVENT_LIST: 'UPDATE_EVENT_LIST',
  CLAIM_MANAGER_RIGHTS: 'CLAIM_MANAGER_RIGHTS',
  USER_ROLES: 'USER_ROLES',
  PROVIDER_ROLES: 'PROVIDER_ROLES',
  EXPORT_CUSTOMERS: 'EXPORT_CUSTOMER',
  JOB_STATUS: 'JOB_STATUS',
  ACTIVE_CUSTOMER_BOOKINGS: 'ACTIVE_CUSTOMER_BOOKINGS',
  CANCELLED_CUSTOMER_BOOKINGS: 'CANCELLED_CUSTOMER_BOOKINGS',
  PAST_CUSTOMER_BOOKINGS: 'PAST_CUSTOMER_BOOKINGS',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  PRODUCT_LIST: 'PRODUCT_LIST',
  PRODUCT_LIST_UPDATE: 'PRODUCT_LIST_UPDATE',
  CURRENCIES: 'CURRENCIES',
  COUNTRIES: 'COUNTRIES',
  TAXGROUPS: 'TAXGROUPS',
  BOOKING_GROUPS: 'BOOKING_GROUPS',
  USC_BOOKING_GROUP: 'USC_BOOKING_GROUP',
  EVENTCATEGORIES: 'EVENT_CATEGORIES',
  SPORTCATEGORIES: 'SPORT_CATEGORIES',
  DEACTIVATE_PROMOCODE: 'DEACTIVATE_PROMOCODE',
  EXTERNAL_PARTIES: 'EXTERNAL_PARTIES',
  EXTERNAL_PARTIES_LOCATION: 'EXTERNAL_PARTIES_LOCATION',
  CUSTOMER_TAGS: 'CUSTOMER_TAGS',
  PROVIDER_CATEGORY_LIST: 'PROVIDER_CATEGORY_LIST',
  SEARCH_GROUPS_CUSTOMERS: 'SEARCH_GROUPS_CUSTOMERS',
  PAYOUTS_LIST: 'PAYOUTS_LIST',
  ATTENDANCE_LIST: 'ATTENDANCE_LIST',
  GET_INVOICE_DOWNLOAD_URL: 'GET_INVOICE_DOWNLOAD_URL',
  DELETE_SINGLE_EVENT: 'DELETE_SINGLE_EVENT',
  GET_ORGANISATION: 'GET_ORGANISATION',
  GET_ORGANISATION_SETTINGS: 'GET_ORGANISATION_SETTINGS',
  GET_ORG_STUDIO_LIST: 'GET_ORG_STUDIO_LIST',
  GET_ORG_STAFF_LIST: 'GET_ORG_STAFF_LIST',
  GET_ORG_STAFF: 'GET_ORG_STAFF',
  GET_USER_FROM_UUID: 'GET_USER_FROM_UUID',
  GET_PROVIDER_FROM_UUID: 'GET_PROVIDER_FROM_UUID',
  STUDIO_CATEGORIES: 'STUDIO_CATEGORIES',
  STUDIO_COUNTRIES: 'STUDIO_COUNTRIES',
  CREATE_PROVIDER: 'CREATE_PROVIDER',
  ORG_USER_ROLES: 'ORG_USER_ROLES',
  INTEGRATION_ROLE: 'INTEGRATION_ROLE',
  INTEGRATION_DELETE: 'INTEGRATION_DELETE',
  CHECK_STUDIO_NAME: 'CHECK_STUDIO_NAME',
  GET_MERCHANT_LIST: 'GET_MERCHANT_LIST',
  ACTIVATE_VOD: 'ACTIVATE_VOD',
  GET_VOD_INTEGRATIONS_LIST: 'GET_VOD_INTEGRATIONS_LIST',
  GET_VOD_INTEGRATION: 'GET_VOD_INTEGRATION',
  GET_VOD_VIDEOS: 'GET_VIDEOS',
  UPLOAD_VOD_VIDEO: 'UPLOAD_VOD_VIDEO',
  MERCHANT_GET_RATES: 'MERCHANT_GET_RATES',
  MERCHANT_GET_DEFAULT_RATE: 'MERCHANT_GET_DEFAULT_RATE',
  MERCHANT_SET_DEFAULT_RATE: 'MERCHANT_SET_DEFAULT_RATE',
  GET_CITY_COUNTRY_LIST: 'GET_CITY_COUNTRY_LIST',
  LOCATION_CANCELLATION_WINDOW: 'LOCATION_CANCELLATION_WINDOW',
  FETCH_CHANNEL_CLASSES: 'FETCH_CHANNEL_CLASSES',
  GET_VOD_VIDEO_URL: 'GET_VOD_VIDEO_URL',
  GET_VOD_VIDEO_BY_ID: 'GET_VOD_VIDEO_BY_ID',
  VALIDATE_IBAN: 'VALIDATE_IBAN',
  START_EXPORT: 'START_EXPORT',
  GET_EXPORT_STATUS: 'GET_EXPORT_STATUS',
  GET_PLACES_AUTO_COMPLETE: 'GET_PLACES_AUTO_COMPLETE',
  GET_PLACES_DETAILS: 'GET_PLACES_DETAILS',
  GET_EVERSPORTS_AUTH_LINK: 'GET_EVERSPORTS_AUTH_LINK',
  LOCATION_FIRST_FREE_CHECKIN: 'LOCATION_FIRST_FREE_CHECKIN',
};

export const STATIC_ACTIONS = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  LOGOUT: 'LOGOUT',
  SEARCH_INPUT_CHANGED: 'SEARCH_INPUT_CHANGED',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
  CLEAR_BOOKING_SEARCH: 'CLEAR_BOOKING_SEARCH',
  CLEAR_IMAGE_UPLOAD: 'CLEAR_IMAGE_UPLOAD',
  CLEAR_ERROR: 'CLEAR_ERROR',
  DISMISS_WARNING: 'DISMISS_WARNING',
  REMOVE_JOB_FROM_REQUEST_LIST: 'REMOVE_JOB_FROM_REQUEST_LIST',
  UPDATE_MOCK_ACCESS_USER_VIEW: 'UPDATE_MOCK_ACCESS_USER_VIEW',
  UPDATE_MOCK_ACCESS_APP_VIEW: 'UPDATE_MOCK_ACCESS_APP_VIEW',
  UPDATE_MOCK_ACCESS_IS_IN_MOCK_MODE: 'UPDATE_MOCK_ACCESS_IS_IN_MOCK_MODE',
  SET_PRODUCT_TOUR: 'SET_PRODUCT_TOUR',
  SET_PRODUCT_TOUR_REF: 'SET_PRODUCT_TOUR_REF',
  CLEAR_PRODUCT_TOURS: 'CLEAR_PRODUCT_TOURS',
  SET_GLOBAL_WARNING: 'SET_GLOBAL_WARNING',
  CLEAR_GLOBAL_WARNING: 'CLEAR_GLOBAL_WARNING',
};

export const ALERT_ACTION = {
  UPDATE_ALERT_VISIBILITY: 'UPDATE_ALERT_VISIBILITY',
};

export const CUSTOMER_LIST_ACTIONS = {
  SELECT_CUSTOMER: 'SELECT_CUSTOMER',
};

export const CUSTOMER_PROFILE_ACTIONS = {
  CLEAR_SELECTED_CUSTOMER: 'CLEAR_SELECTED_CUSTOMER',
};

export const EVENT_LIST_ACTIONS = {
  SELECT_EVENT: 'SELECT_EVENT',
  UNSELECT_EVENT: 'UNSELECT_EVENT',
};

export const BOOKING_LIST_ACTIONS = {
  UPDATE_SELECTION: 'UPDATE_SELECTION',
  SELECT_ALL: 'SELECT_ALL',
  CHECKIN_STATUS: 'CHECKIN_STATUS',
  CLEAR: 'CLEAR',
  SELECT_CUSTOMER: 'BOOKING_SELECT_CUSTOMER',
  CLEAR_SELECTED_CUSTOMERS: 'CLEAR_SELECTED_CUSTOMERS',
};

export const IMPORT_ACTIONS = {
  GET_IMPORT: 'GET_IMPORT',
  POST_IMPORT: 'POST_IMPORT',
  POST_IMPORT_FILE: 'POST_IMPORT_FILE',
  GET_IMPORT_LIST: 'GET_IMPORT_LIST',
};

export const ZOOM_ACTIONS = {
  GET_ZOOM_INTEGRATION_API: 'GET_ZOOM_INTEGRATION_API',
  POST_ZOOM_SESSION_SETUP: 'POST_ZOOM_SESSION_SETUP',
};
